var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75479 5.41651C7.09779 5.41651 6.08079 4.66951 5.00979 4.69651C3.59679 4.71451 2.30079 5.51551 1.57179 6.78451C0.104789 9.33151 1.19379 13.0935 2.62479 15.1635C3.32679 16.1715 4.15479 17.3055 5.25279 17.2695C6.30579 17.2245 6.70179 16.5855 7.97979 16.5855C9.24879 16.5855 9.60879 17.2695 10.7248 17.2425C11.8588 17.2245 12.5788 16.2165 13.2718 15.1995C14.0728 14.0295 14.4058 12.8955 14.4238 12.8325C14.3968 12.8235 12.2188 11.9865 12.1918 9.46651C12.1738 7.36051 13.9108 6.35251 13.9918 6.30751C13.0018 4.85851 11.4808 4.69651 10.9498 4.66051C9.56379 4.55251 8.40279 5.41651 7.75479 5.41651ZM10.0948 3.29251C10.6798 2.59051 11.0668 1.60951 10.9588 0.637512C10.1218 0.673512 9.11379 1.19551 8.51079 1.89751C7.97079 2.51851 7.50279 3.51751 7.62879 4.47151C8.55579 4.54351 9.50979 3.99451 10.0948 3.29251Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.408704c2f6b9b067ad23b2d5993dd57c.svg";
export { ForwardRef as ReactComponent };